<template>
  <div class="formGroup isRequired mt15">
    <label class="label toCapitalize notranslate">{{locale.reservation_place}}</label>
    <SeatMap
      :locale="locale"
      :lang="lang"
      :seats="seats"
      :objects="seatMap.seatObj"
      :info="seatMap.info"
      :count="seatCount"
      :activeTarget="activeTarget"
      @activeSeat="activeSeat" />
  </div>
</template>

<script>
import moment from 'moment/moment'
import regExp from '@/common/regExp'
import Summary from '@/components/Reservation/Summary'
import SeatMap from '@/components/Reservation/SeatMap'

export default {
  name: 'ReservationFormSeat',
  props: [
    'lang',
    'ln',
    'locale',
    'info',
    'roomKey',
    'rid',
    'isPublic',
    'seatMap',
    'seatCount',
    'remainSeat'
  ],
  components: {
    SeatMap
  },
  computed: {
    activeTarget () {
      return this.seat && this.seat.map(x => x.seatId)
    },
    seats () {
      const seats = this.seatMap.seats
      const remain = this.remainSeat
      const list = seats.map(x => {
        const isDisabled = !(remain && remain[x.placeId] && remain[x.placeId].remainSeats && remain[x.placeId].remainSeats.includes(x.seatId))
        return {
          ...x,
          disabled: x.disabled || isDisabled
        }
      })
      return list
    }
  },
  mounted () {
    const seats = this.seatMap.seats
    const remain = this.remainSeat
    const list = seats.map(x => {
      const isDisabled = !(remain && remain[x.placeId] && remain[x.placeId].remainSeats && remain[x.placeId].remainSeats.includes(x.seatId))
      return {
        id: x.seatId,
        place: x.placeId,
        remainSeats: remain && remain[x.placeId] && remain[x.placeId].remainSeats,
        isRemain: remain && remain[x.placeId] && remain[x.placeId].remainSeats && remain[x.placeId].remainSeats.includes(x.seatId)
      }
    })
  },
  data () {
    return {
      seat: []
    }
  },
  methods: {
    activeSeat (data) {
      const count = this.seatCount
      const length = this.seat.length
      function toggle (arr, data) {
        return arr.find(x => x.seatId === data) ? arr.filter(x => x.seatId !== id) : [...arr, data]
      }
      function remove (arr, id) {
        return arr.filter(x => x.seatId !== id)
      }
      if (count > 1) {
        if (count > length) {
          this.seat = toggle(this.seat, data)
        } else if (count === length && this.seat.find(x => x.seatId === data.seatId)) {
          this.seat = remove(this.seat, data.seatId)
        }
      } else if (count === 1) {
        this.seat = [data]
      }
      this.$emit('setSeatMap', this.seat)
    }
  }
}
</script>
